import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

/**
 * Watches the logged-in user; if they are a tenant admin whose tenant
 * has setup_completed=false, forces a redirect to /setup until the
 * wizard is finished. Runs once per page-load.
 */
export default function SetupGuard({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (!user || checked) return;
    if (user.is_super_admin) { setChecked(true); return; }
    const roles = user.roles || (user.role ? [user.role] : []);
    if (!roles.includes('admin')) { setChecked(true); return; }
    (async () => {
      try {
        const { data } = await api.get('/setup/status');
        if (!data.setup_completed && loc.pathname !== '/setup' && loc.pathname !== '/profile' && loc.pathname !== '/change-password') {
          nav('/setup', { replace: true });
        }
      } catch (e) { /* ignore */ }
      finally { setChecked(true); }
    })();
  }, [user, checked, nav, loc.pathname]);
  return children;
}
